// extracted by mini-css-extract-plugin
export var modal = "_tx-0";
export var table = "_tx-1";